export default class CAJA1110RequestModel {}
